import axios from 'axios';
import { Imports } from '../../Imports';
import { environment as env, environment } from '../../environments/environment';
import { setPageLoader } from '../../redux/features/utils.slice';
import { utility } from '../../helpers/loader';
import { showSnackBar } from '../../helpers/showSnackBar';
import { notification, message as antdMessage } from 'antd';
import { useHistory } from 'react-router-dom';
import { errorMessage } from '../../helpers';
const axiosInstance = axios.create();
const { httpMessages } = Imports;
const token = localStorage.getItem("access_jwt")



const requestHandler = (request) => {
    const { url: apiToConsume } = request;


    const url = env.apiPath.concat(apiToConsume);
    Object.assign(
        request,
        { url }
    )
    if (apiToConsume !== 'employee/employee/update_session') utility?.dispatch(setPageLoader({ pageName: "main", flag: true }))

    return request;

}
const responseHandler = (response) => {
    utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
    return response;
}
const errorHandler = async (error) => {


    if ([400, 403, 417, 411].includes(error?.response?.status)) {
        antdMessage.destroy()
        antdMessage.error(error?.response?.data?.message);
    }
    if (!error.response) { return }

    utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
    let pastScreen = localStorage.getItem('pastScreen')
    let isEmployee = JSON.parse(localStorage.getItem('isEmployee'))
    console.log("🚀 ~ errorHandler ~ isEmployee:", isEmployee)


    if (error.response.status === 401) {

        if ([`${environment.apiPaths.base}/api/employee/employee/login`, `${environment.apiPaths.base}/api/employee/applicant/login`].includes(error?.response?.config?.url)) {
            utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
            antdMessage?.error("Invalid Credentials")
            return
        }
        if ([true, "true"].includes(isEmployee) && pastScreen === 'Employee') {
            localStorage.clear()
            localStorage.setItem('pastScreen', "Employee")
            window.location.href = '/login/140040'
            if (error?.response?.data?.message == 'session_expired') {
                antdMessage.destroy()
                antdMessage.error('Your account has been logged in on another device');
            } else {
                errorMessage()
            }


            return
        }

        if ([false, "false"].includes(isEmployee) && pastScreen === 'Applicant') {
            localStorage.clear()
            window.location.href = '/'
            errorMessage()
            return
        }
    }


    let {
        response: {
            data: { message },
            data: detail
        }
    } = error;

    const messageToShow = httpMessages[message];

    detail = { ...detail, messageToShow };


    if (detail.message == 'BadEmail') {
        antdMessage.destroy()
        antdMessage.error("Incorrect Email")
        utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
        throw error;
    }
    if (detail.message == 'InvalidPassword') {
        antdMessage.destroy()
        antdMessage.error("Incorrect Password")
        utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
        throw error;
    }
    if (detail.message == 'invalid_credentials') {
        antdMessage.destroy()
        antdMessage.error("Incorrect Username Or Password")
        utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
        throw error;
    }
    antdMessage.destroy()
    if (detail.message) antdMessage.error(detail?.message)

    utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))

    throw error;
}

axiosInstance.interceptors.request
    .use(
        requestHandler,
        errorHandler
    )

axiosInstance.interceptors.response
    .use(
        responseHandler,
        errorHandler
    );

/** Overwriting Post as a Repository for HTTP Interface */

axiosInstance.postMethod = axiosInstance.post;
axiosInstance.getMethod = axiosInstance.get;
axiosInstance.putMethod = axiosInstance.put;
// axiosInstance.delete = axiosInstance.delete;
axiosInstance.optionsMethod = axiosInstance.options;

const HTTPClientFunctionsWrapper = async (method, ...args) => {
    try {
        /** Not using a try-catch block deliberately to allow global handlers to manage
     * it.
     */
        const [uri, ...rest] = args;
        let [payload = {}, headers = {}] = rest;
        const AuthorizationExtracted = localStorage.getItem('access_jwt');
        const { Authorization: AuthorizationPassed } = headers;
        headers = {
            ...headers,
            Authorization: AuthorizationPassed || AuthorizationExtracted
        };
        const requestArguments = [
            uri,
            payload,
            {
                headers,
            }
        ]
        /** REMOVING PAYLOAD IF REQUEST METHOD IS GET */
        if ((method.includes('get')))
            requestArguments.splice(1, 1);
        // HTTP Requests 
        const response = await axiosInstance[method](...requestArguments) || {};
        const { data: axiosObjectData } = response;
        return axiosObjectData;
    } catch (exc) {

        throw exc;
    }
}

const newPostMethod = HTTPClientFunctionsWrapper.bind(null, 'postMethod');
const newGetMethod = HTTPClientFunctionsWrapper.bind(null, 'getMethod');
const newPutMethod = HTTPClientFunctionsWrapper.bind(null, 'putMethod');
const newOptionsMethod = HTTPClientFunctionsWrapper.bind(null, 'optionsMethod');

Object.assign(
    axiosInstance,
    {
        post: newPostMethod,
        get: newGetMethod,
        put: newPutMethod,
        options: newOptionsMethod,
    },
)

axiosInstance.post = newPostMethod;
axiosInstance.get = newGetMethod;
axiosInstance.put = newPutMethod;
axiosInstance.options = newOptionsMethod;
/** */

export const Interceptor = { axiosInstance };
